import DonutAdapter from "./adapters/DonutAdapter";
import TimeseriesAdapter from "./adapters/TimeseriesAdapter";
import ComparisonBarAdapter from "./adapters/ComparisonBarAdapter";
import TableAdapter from "./adapters/TableAdapter";
import DeltaBarAdapter from "./adapters/DeltaBarAdapter";
import RadarAdapter from "./adapters/RadarAdapter";
import VegaAdapter from "./adapters/VegaAdapter";

class ChartRegistry {
  constructor() {
    this.adapters = new Map();
    this.initDefaults();
  }

  initDefaults() {
    // Donut / Pie distribution charts
    this.register("donut", DonutAdapter);
    this.register("pie", DonutAdapter);
    this.register("share", DonutAdapter);

    // Timeseries / Trend line and area charts
    this.register("timeseries", TimeseriesAdapter);
    this.register("area", TimeseriesAdapter);
    this.register("line", TimeseriesAdapter);
    this.register("trend", TimeseriesAdapter);

    // Comparison Bar / Grouped bar charts
    this.register("comparison_bar", ComparisonBarAdapter);
    this.register("grouped_bar", ComparisonBarAdapter);
    this.register("bar", ComparisonBarAdapter);

    // Delta / Change Bar charts
    this.register("delta_bar", DeltaBarAdapter);
    this.register("delta", DeltaBarAdapter);

    // Radar / Coverage spider charts
    this.register("radar", RadarAdapter);
    this.register("spider", RadarAdapter);

    // Vega & Vega-Lite arbitrary analytical charts
    this.register("vega_lite", VegaAdapter);
    this.register("vegalite", VegaAdapter);
    this.register("vega", VegaAdapter);
    this.register("advanced", VegaAdapter);

    // Tabular data
    this.register("table", TableAdapter);
  }

  register(type, adapter) {
    if (!type || typeof adapter !== "function") return;
    this.adapters.set(type.toLowerCase().trim(), adapter);
  }

  get(type) {
    if (!type) return TableAdapter;
    return this.adapters.get(type.toLowerCase().trim()) || TableAdapter;
  }

  has(type) {
    if (!type) return false;
    return this.adapters.has(type.toLowerCase().trim());
  }

  getSupportedTypes() {
    return Array.from(this.adapters.keys());
  }
}

export const chartRegistry = new ChartRegistry();
export { ChartRegistry };
export default chartRegistry;
